import { useState } from "react";
import socket from "../../services/socket";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./Login.css";

function Login() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });
   
  const [loading, setLoading] = useState(false);

 const handleLogin = async () => {

  if (!form.email || !form.password) {
    alert("Please enter email and password.");
    return;
  }

  try {

    setLoading(true);

    const res = await API.post("/auth/login", form);

    localStorage.setItem(
    "token",
    res.data.token
);

localStorage.setItem(
    "role",
    res.data.user.role
);

localStorage.setItem(
    "user",
    JSON.stringify(res.data.user)
);
switch (res.data.user.role) {

    case "customer":

        socket.emit(
            "register-customer",
            res.data.user.id
        );

        localStorage.setItem("mode", "customer");

        navigate("/home", { replace: true });

        break;

    case "provider":

        socket.emit(
            "register-provider",
            res.data.user.id
        );

        localStorage.setItem("mode", "business");

        navigate("/business/home", { replace: true });

        break;

    case "delivery":

        socket.emit(
            "register-delivery",
            res.data.user.id
        );

        localStorage.setItem("mode", "delivery");

        navigate("/delivery/home", { replace: true });

        break;

    case "admin":

        socket.emit(
            "register-admin",
            res.data.user.id
        );

        navigate("/admin/dashboard", { replace: true });

        break;

    default:

        navigate("/", { replace: true });

}

    switch (res.data.user.role) {

      case "provider":
        localStorage.setItem("mode", "business");
        navigate("/business/home", { replace: true });
        break;

      case "delivery":
        localStorage.setItem("mode", "delivery");
        navigate("/delivery/home", { replace: true });
        break;

      case "customer":
        localStorage.setItem("mode", "customer");
        navigate("/home", { replace: true });
        break;

      case "admin":
        navigate("/admin/dashboard", { replace: true });
        break;

      default:
        navigate("/", { replace: true });

    }

  } catch (error) {

    console.log(error.response?.data);

    alert(
      error.response?.data?.message ||
      "Login Failed"
    );

  } finally {

    setLoading(false);

  }

};
  return (

    <div className="login-page">

      <div className="login-card">

        {/* Logo */}

        <div className="login-logo">

          <div className="logo">

            🍽

          </div>

          <h1>HomeFoods</h1>

          <p>

            Fresh Homemade Food

            <br />

            Delivered with ❤️

          </p>

        </div>

        {/* Email */}

        <div className="input-group">

          <input

            type="email"

            placeholder=" "

            value={form.email}

            onChange={(e) =>

              setForm({

                ...form,

                email: e.target.value

              })

            }

          />

          <label>Email Address</label>

        </div>

        {/* Password */}

        <div className="input-group">

          <input

            type="password"

            placeholder=" "

            value={form.password}

            onChange={(e) =>

              setForm({

                ...form,

                password: e.target.value

              })

            }

          />

          <label>Password</label>

        </div>

        {/* Login Button */}

        <button

          className="login-btn"

          onClick={handleLogin}

          disabled={loading}

        >

          {loading ? "Logging In..." : "Login"}

        </button>

        {/* Links */}

        <div className="login-links">

          <p

            className="forgot"

            onClick={() => navigate("/forgot-password")}

          >

            Forgot Password?

          </p>

          <p>

            Don't have an account?

            <span

              onClick={() => navigate("/register")}

            >

              {" "}Register

            </span>

          </p>

        </div>

      </div>

    </div>

  );

}

export default Login;